import React, { useState, useEffect } from 'react';
import { Outlet } from 'react-router-dom'
import Navbar from '../layouts/navbar'
import Loader from '../layouts/loader';

const DashboardLayout = ({ children }) => {
  const [authToken, setAuthToken] = useState(null);
  const [loader, setLoader] = useState(true);

  // Improved token parsing function
  const parseTokenFromUrl = () => {
    try {
      const urlParams = new URLSearchParams(window.location.search);
      const token = urlParams.get('ref');

      if (!token) {
        console.log("No token found in URL parameters");
        return null;
      }

      // First decode URI component (handles URL encoding like %22, %3A, etc.)
      const decodedToken = decodeURIComponent(token);
      // console.log("Decoded token:", decodedToken);

      // Try to parse as JSON
      try {
        const parsedToken = JSON.parse(decodedToken);
        // console.log("Successfully parsed JSON token:", parsedToken);
        return parsedToken;
      } catch (jsonError) {
        console.error("JSON parsing failed:", jsonError);
        return null;
      }
    } catch (error) {
      console.error("Error parsing token from URL:", error);
      return null;
    }
  };

  useEffect(() => {
    let userTokenDetails = sessionStorage.getItem('tokenDetails');
    // console.log("userTokenDetails", userTokenDetails);

    // Use the improved token parsing
    const decodedRef = parseTokenFromUrl();

    if (decodedRef && decodedRef.token) {
      try {

        setAuthToken(decodedRef.token);
        localStorage.setItem('authToken', decodedRef.token);
        sessionStorage.setItem("userDetail", JSON.stringify(decodedRef));

        // Store org_id if available
        if (decodedRef.org_id) {
          localStorage.setItem("ORGID", decodedRef.org_id);
        }

        // Clean up URL by removing query parameters
        window.history.replaceState({}, document.title, window.location.pathname);
      } catch (error) {
        console.error("Failed to process decoded token:", error);
      }
    } else {
      console.log("No valid token found or token structure is invalid");
    }
    setLoader(false);
  }, []);

  return (
    <>
      {loader ? <Loader /> :
        <Navbar children={children} showFooter={false}>
          <Outlet />
        </Navbar>
      }
    </>
  );
};

export default DashboardLayout;